import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import moment from "moment";
import UploadSKBloc from "./Blocs/UploadSKBloc";

var reformatOptionRank = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = `${data.rank_name} (${data.rank_group_room})`;
    newObj["value"] = data.rank_uuid;
    return newObj;
  });
};

var reformatSignatory = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] =
      region.signatories_official_nip +
      " - " +
      region.signatories_official_name;
    newObj["value"] = region.signatories_official_uuid;
    newObj["nip_pejabat"] = region.signatories_official_nip;
    newObj["nama_pejabat"] = region.signatories_official_name;
    return newObj;
  });
};

var reformatOptionDocument = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.document_type_name;
    newObj["value"] = region.document_type_uuid;
    return newObj;
  });
};

class IndexView extends Component {
  uploadSKBloc = new UploadSKBloc();

  queryParams = new URLSearchParams(window.location.search);

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        nip_pejabat: "",
        nama_pejabat: "",
        sumpahSelected: "",
      },
      rankItems: [],
      rankSelected: "",
      sigantoryItems: [],
      sigantorySelected: "",
      documentTypeItems: [],
      documentTypeSelected: "",
      status_name: "",
    };
  }

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  dateParseYMD = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("YYYY-MM-DD");
    }
    return res;
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  onChangeSumpah = (event) => {
    const target = event.target;
    const value = target.checked ? 1 : 0;
    this.setState({
      dataForm: {
        sumpahSelected: value,
      },
    });
  };

  onchangeRank = (rankSelected) => {
    this.setState({
      rankSelected: rankSelected.value,
    });
  };

  onChangeDcoumentType = (documentTypeSelected) => {
    this.setState({
      documentTypeSelected: documentTypeSelected.value,
    });
  };

  onChangeSignatory = (signatory) => {
    this.setState({
      sigantorySelected: signatory.value,
      dataForm: {
        nip_pejabat: signatory.nip_pejabat,
        nama_pejabat: signatory.nama_pejabat,
      },
    });
  };

  submitData = async () => {
    let documents = ["document_prajab", "document_mcu"];
    const formData = generateFormData(this.state.dataForm, documents); // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.uploadSKBloc.fetchUploadSk(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        cpns_uuid: this.state.detail?.cpns_uuid,
        employee_uuid: this.state.detail?.employee_uuid,
      },
      confirm: true,
    });
  };

  rupiah = (num) => {
    let res = "-";
    if (num != null && num != "") {
      res = parseFloat(num).toLocaleString("id-ID", {
        maximumFractionDigits: 2,
      });
    }
    return res;
  };

  confirmResponse = (response) => {
    debugger;
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.uploadSKBloc.uploadSkChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            // load to form
            this.setState({
              detail: response,
              birthNational: response.cpns_candidate_place_of_birth_national,
              rankSelected: response.cpns_candidate_rank_uuid,
              status_name: response.cpns_pns_status_submit_name,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.rankChanel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              rankItems: reformatOptionRank(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.signatoryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              sigantoryItems: reformatSignatory(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.documentTypeChanel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              documentTypeItems: reformatOptionDocument(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.fetchDetail({ uuid: this.queryParams.get("uuid") });
    this.uploadSKBloc.fetchRank();
    this.uploadSKBloc.fetchSignatory();
    this.uploadSKBloc.fetchDocumentType();

    this.setState({
      dataForm: {
        sumpahSelected: 0,
      },
    });
  }

  componentWillUnmount() {
    this.uploadSKBloc.uploadSkChannel.unsubscribe();
    this.uploadSKBloc.detailChannel.unsubscribe();
    this.uploadSKBloc.rankChanel.unsubscribe();
    this.uploadSKBloc.signatoryChannel.unsubscribe();
    this.uploadSKBloc.documentTypeChanel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    Upload Dokumen PRAJAB & Medical Check Up
                  </CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {/* <AvField
                                                name="cpns_uuid"
                                                type="hidden"
                                                value={this.state.detail?.cpns_uuid}
                                            />

                                            <AvField
                                                name="employee_uuid"
                                                type="hidden"
                                                value={this.state.detail?.employee_uuid}
                                            /> */}

                    {/* <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Penetapan NIP BKN
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_bkn_confirmation_number"
                                                        placeholder="Nomor"
                                                        errorMessage="Masukkan Nomor"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_bkn_confirmation_number}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_bkn_confirmation_date"
                                                        placeholder="Tanggal"
                                                        errorMessage="Masukkan Tanggal"
                                                        type="date"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_bkn_confirmation_date}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row> */}

                    <hr />

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nama Lengkap
                      </Label>
                      <Col md="4">
                        <AvField
                          name="cpns_candidate_name"
                          placeholder="Nama"
                          errorMessage="Masukkan Nama"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cpns_candidate_full_name}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">NIP</Label>
                      <Col md="3">
                        <AvField
                          name="cpns_candidate_nip"
                          placeholder="NIP"
                          errorMessage="Masukkan NIP"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cpns_candidate_nip}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Tempat Lahir
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_national"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.birthNational}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_country_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_place_of_birth_country_name}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3" style={ this.state.birthNational == "Dalam Negeri" ? {} : {display:'none'}}>
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_province_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_place_of_birth_province_name}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_city_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_place_of_birth_city_name}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3" style={ this.state.birthNational == "Dalam Negeri" ? {display:'none'} : {}}>
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                </Label>
                                                <Col md="5">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_national"
                                                        placeholder="Kota..."
                                                        type="text"
                                                        errorMessage="Masukkan Kota"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_place_of_birth_city_text}
                                                        validate={{ required: { value: this.state.birthNational == "Dalam Negeri" ? false : true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Tanggal Lahir
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_date_of_birth"
                                                        placeholder="Tanggal Lahir"
                                                        errorMessage="Masukkan Tanggal Lahir"
                                                        type="date"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_date_of_birth}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Jenis Kelamin
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_gender_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_gender_name}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Pendidikan Terakhir
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_last_education_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_last_education_name}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_last_education_major"
                                                        placeholder="Program Studi / Jurusan"
                                                        errorMessage="Masukkan Program Studi"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_last_education_major}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Pangkat
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_rank_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={`${this.state.detail?.cpns_candidate_rank_name} (${this.state.detail?.cpns_candidate_rank_group_room})`}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Jabatan
                                                </Label>
                                                <Col md="6">
                                                    <AvField
                                                        name="cpns_candidate_position_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_position_name}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Unit Kerja
                                                </Label>
                                                <Col md="6">
                                                    <AvField
                                                        name="cpns_candidate_work_unit_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.detail?.cpns_candidate_work_unit_name}
                                                        validate={{ required: { value: false } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.sigantoryItems.filter(option => 
                                                      option.value === this.state.sigantorySelected)}
                                                    onChange={
                                                      this.onChangeSignatory
                                                    }
                                                    required="required"
                                                    options={this.state.sigantoryItems}
                                                    classNamePrefix=""
                                                />
                                                <AvField
                                                    name="sigantory_id"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="sigantory_id"
                                                    value={this.state.sigantorySelected}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="nama_pejabat"
                                                    id="nama_pejabat"
                                                    placeholder="Nama Pejabatan Penetap"
                                                    type="text"
                                                    className="form-control"
                                                    readOnly
                                                    value={this.state.dataForm.nama_pejabat}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="nip_pejabat"
                                                    id="nip_pejabat"
                                                    placeholder="NIP Pejabatan Penetap"
                                                    type="text"
                                                    className="form-control"
                                                    readOnly 
                                                    value={this.state.dataForm.nip_pejabat}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No Surat Keputusan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="no_sk"
                                                    id="no_sk"
                                                    placeholder="Nomor Surat Keputusan..."
                                                    type="text"
                                                    errorMessage="Nomor Surat Keputusan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Keputusan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_sk"
                                                    placeholder="Tanggal SK..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tanggal_sk"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Terhitung Mulai Tanggal <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_tmt_sk"
                                                    placeholder="Terhitung Mulai Tanggal..."
                                                    type="date"
                                                    errorMessage="Masukkan Terhitung Mulai Tanggal"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tanggal_tmt_sk"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No Diklat Prajabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="no_diklat"
                                                    id="no_diklat"
                                                    placeholder="Nomor Diklat..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Diklat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Diklat Prajabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_diklat"
                                                    placeholder="Tanggal Diklat..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Diklat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tanggal_diklat"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No Surat Uji Kesehatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="no_surat_kesehatan"
                                                    id="no_surat_kesehatan"
                                                    placeholder="Masukan No Surat Uji Kesehatan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Surat Uji Kesehatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Uji Kesehatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_kesehatan"
                                                    placeholder="Tanggal Surat Uji Kesehatan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Surat Uji Kesehatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tanggal_kesehatan"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Golongan Ruang <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.rankItems.filter(option => 
                                                      option.value === this.state.rankSelected)}
                                                    onChange={
                                                      this.onchangeRank
                                                    }
                                                    required="required"
                                                    options={this.state.rankItems}
                                                    classNamePrefix=""
                                                />
                                                <AvField
                                                    name="rank_id"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="rank_id"
                                                    value={this.state.rankSelected}
                                                />
                                            </Col>
                                        </Row> */}

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File Prajab <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_prajab"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File Medical Check Up{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_mcu"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Status</Label>
                      <Col md="4">
                        <label className="col-md-6 col-form-label">
                          {this.state.status_name}
                        </label>
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pengambilan Sumpah{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <input
                          name="Sumpah"
                          type="checkbox"
                          checked={this.state.isChecked}
                          onChange={this.onChangeSumpah}
                        />
                        <AvField
                          name="sumpah_selected"
                          type="hidden"
                          id="sumpah_selected"
                          value={this.state.dataForm.sumpahSelected}
                        />
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`/kepegawaian/dokumen_pns.html`}>
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={`/kepegawaian/dokumen_pns.html`} />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
